<template>
  <div>
    <b-modal id="modal_combine_counts" ref="modal_combine_counts" title="COMBINE" :ok-only="true" ok-title="Next"
      size="sm" :no-close-on-backdrop="true" @ok="handleOk" @show="resetModal" @hidden="resetModal">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="Please select an account:" label-for="account-input" invalid-feedback="Account is required"
          :state="accountState">
          <b-form-select v-model="selectedAccountId" id="account-input" v-if="roleName === 'Reseller'"
            class="account-select" :state="accountState" required>
            <option v-for="item in accountList" :value="item.AccountId">
              {{ item.AccountDesc }}
            </option>
          </b-form-select>
        </b-form-group>
      </form>
    </b-modal>
    <b-modal id="modal_confirm_delete" ref="modal_confirm_delete" title="Confirm" ok-title="Yes"
      :no-close-on-backdrop="true" @ok="handleDeleteOk">
      <p>Are you sure you want to delete the selected records?</p>
    </b-modal>
    <b-row class="justify-content-md-center filter">
      <b-col xl="9" lg="9" md="9" sm="9" class="left-title"><b-input-group class="mb-2">
          <b-input-group-prepend is-text>
            <icon name="search" />
          </b-input-group-prepend>
          <b-form-input class="search-text" v-model="searchKey" @input="searchChange"
            placeholder="Search for order ID, name to filter" aria-label="Text input with checkbox"></b-form-input>

          <div class="filter_date_start">
            <!-- <datepicker v-model="startDate" placeholder="Start Date" @input="leadPageChange"></datepicker> -->
            <b-form-datepicker v-model="startDate" placeholder="Start Date" @input="leadPageChange"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="en"></b-form-datepicker>
          </div>
          <div class="filter_date_to"><span>to</span></div>
          <div class="filter_date_end">
            <b-form-datepicker v-model="endDate" placeholder="End Date" @input="leadPageChange"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="en"></b-form-datepicker>
          </div>

        </b-input-group>
      </b-col>
      <b-col xl="3" lg="3" md="3" sm="3" class="right-title">
        <b-form-select v-model="accountId" @change="leadPageChange" v-if="roleName === 'Reseller'" class="account-select">
          <option value="0">All Accounts</option>
          <option v-for="item in accountList" :value="item.AccountId">
            {{ item.AccountDesc }}
          </option>
        </b-form-select>
        <b-btn v-if="selectedRows.length >= 2" @click="showSelectAccount">COMBINE</b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table striped hover :fields="leadsFields" :items="LeadData">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(Account)="data">
            <span>{{ roleName === "Power User" ? data.item.UserName : (roleName === "Reseller" ? data.item.AccountName :
              "")
            }}</span>
          </template>
          <template #cell(Action)="data">
            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <icon name="ellipsis-v" />
              </template>
              <b-dropdown-item href="javascript:void(0)" @click="showDelteConfirm(data.item.OrderId.toString())">Delete</b-dropdown-item>
              <b-dropdown-item :href="$store.getters['config/link']('getSavedCount')+data.item.SessionId">Edit</b-dropdown-item>
            </b-dropdown>
          </template>
          <template #cell(Chk)="data">
            <b-form-checkbox @change="rowSelectedChanged(data.item)"></b-form-checkbox>
          </template>
        </b-table>
        <b-row>
          <b-col md="5" class="pageinfo">
            1-{{
              totalLeadDataCount % leadPageSize === 0
              ? totalLeadDataCount % leadPageSize
              : parseInt(totalLeadDataCount / leadPageSize) + 1
            }}
            of
            {{ totalLeadDataCount }}
          </b-col>
          <b-col>
            <b-pagination v-model="LeadDataCurrentPage" page-class="page-class" :total-rows="totalLeadDataCount"
              @change="leadPageChange" prev-text="＜PREVIOUS" next-text="NEXT＞" first-text="First" last-text="Last"
              align="left"></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MBase from "@/components/layouts/MBase";
import utils from "@/assets/utils";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    MBase,
    Datepicker
  },
  data() {
    return {
      accountId: "0",
      searchKey: "",
      tabType: -1,
      startDate: "",
      endDate: "",
      selectedRows: [],
      selectedAccountId: "",
      accountState: null,
      selectedDeleteCountId: "",
      leadsFields: [
        { label: "", key: "Chk" },
        {
          label: "Date Added",
          key: "OrderDate",
          formatter: (value) => {
            return utils.dateFormat(value, "MM/DD/YYYY");
          },
        },
        {
          label: "Exp. Date",
          key: "ExpirationDate",
          formatter: (value) => {
            return utils.dateFormat(value, "MM/DD/YYYY");
          },
        },
        { label: "List ID", key: "OrderCode" },
        { label: "List Name", key: "OrderDesc" },
        { label: "Type", key: "DataSourceDesc" },
        {
          label: "Price",
          key: "TotalEstmCost",
          formatter: (value) => {
            return utils.numberFormat(value);
          },
        },
        {
          label: "Quantity",
          key: "TotalDesiredQty",
          formatter: (value) => {
            return utils.numberFormat(value, "", 0);
          },
        },

        { label: "Account", key: "Account" },
        { label: "Action", key: "Action" },
      ],
      LeadData: [],
      totalLeadDataCount: 0,
      leadPageSize: 18,
      LeadDataCurrentPage: 1,
      isOrderBusy: true,
    };
  },
  computed: {
    accountList() {
      return this.$store.getters["user/accountList"];
    },
    roleName() {
      return this.$store.state.site.User_RoleName;
    },
  },
  created() {
    this.$http
      .post("rpt/MySavedCount.aspx/GetInitSaveData", {
        pagingOptions: {
          PageNumber: 1,
          PageSize: this.leadPageSize,
          Start: 0,
          SortBy: "OrderDate",
          SortDescending: true,
          FetchTotalRecordCount: true,
          TotalRecordCount: 0,
        },
      })
      .then(
        (resp) => {
          this.LeadData = resp.body.d.DataSource.ReportData.Items;
          this.isOrderBusy = false;
          this.totalLeadDataCount =
            resp.body.d.DataSource.ReportData.TotalRecordCount;
        },
        (resp) => { }
      );
  },
  methods: {
    leadPageChange() {
      this.isOrderBusy = true;
      this.$http
        .post("rpt/MySavedCount.aspx/GetOrderHisotry", {
          accountId: this.accountId,
          orderName: "",
          orderNumber: "",
          searchKey: this.searchKey,
          startDate: this.startDate,
          endDate: this.endDate,
          userEmail: "",
          pagingOptions: {
            PageNumber: this.LeadDataCurrentPage,
            PageSize: this.leadPageSize,
            Start: 0,
            SortBy: "OrderDate",
            SortDescending: true,
            FetchTotalRecordCount: true,
            TotalRecordCount: 0,
          },
        })
        .then(
          (resp) => {
            this.LeadData = resp.body.d.DataSource.ReportData.Items;
            this.isOrderBusy = false;
            this.totalLeadDataCount =
              resp.body.d.DataSource.ReportData.TotalRecordCount;
          },
          (resp) => { }
        );
    },
    searchChange() {
      if (this.searchKey.length >= 3 || this.searchKey === "") {
        this.leadPageChange();
      }
    },
    tabClick(val) {
      this.tabType = val;
    },
    getAccountName(data) {
      if (this.roleName === "Power User") return data.AccountName;
      else if (this.roleName === "Reseller") return data.UserName;
      else return "";
    },
    rowSelectedChanged(data) {
      if (this.selectedRows.find(x => {
        return x.OrderId === data.OrderId
      })) {
        this.selectedRows = this.selectedRows.filter(x => {
          return x.OrderId !== data.OrderId
        })
      }
      else {
        this.selectedRows.push(data)
      }
      console.log(this.selectedRows)
    },
    showSelectAccount() {
      this.$refs.modal_combine_counts.show();
    },
    resetModal() {
      this.selectedAccountId = ''
      this.accountState = null
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.accountState = valid
      return valid
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      console.log(this.selectedAccountId)
      var multiCountOrderGeos = [];
      this.selectedRows.map(x => {
        multiCountOrderGeos.push({
          GeoKeyCode: x.OrderId,
          GeoKeyDesc: x.OrderCode + ' (' + x.OrderDesc + ')',
          CostPrice: x.CostPrice,
          CityName: "",
          CountryCode: "US",
          AvailableQty: 0
        })
      })
      this.postMultiCountOrder(multiCountOrderGeos)
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal_combine_counts')
      })
    },
    postMultiCountOrder(geos) {
      var that = this;
      this.$http
        .post("rpt/MySavedCount.aspx/PostMultiCountOrder", {
          accountId: that.selectedAccountId,
          multiCountOrderGeos: geos
        })
        .then(
          (resp) => {
            if (resp.body.d.ResultFlag) {
              window.location.href = this.$store.getters["config/link"](
                "postMultiCountOrder"
              );
            } else {
              that.setError(resp);
            }
          },
          (resp) => {
            that.setError(resp);
          }
        );
    },
    setError(resp) {
      this.isOrdering = false;
      notificaton.notice("error", resp, {
        title: "Error",
        onlyGroup: "connectError",
      });
    },
    showDelteConfirm(countId) {
      this.selectedDeleteCountId = countId;
      this.$refs.modal_confirm_delete.show();
    },
    handleDeleteOk() {
      if (this.selectedDeleteCountId) {
        var orderIds = [];
        orderIds.push(this.selectedDeleteCountId)
        var that = this;
        this.$http
          .post("rpt/MySavedCount.aspx/DeleteSavedCount", {
            orderIds: orderIds
          })
          .then(
            (resp) => {
              if (resp.body.d.ResultFlag) {
                that.leadPageChange();
              } else {
                that.setError(resp);
              }
            },
            (resp) => {
              that.setError(resp);
            }
          );
      }

    }
  },
};
</script>

<style scoped lang="scss">
.title {
  text-align: center;
  font-weight: bold;
  color: black;
}

.content {
  display: flex;
  justify-content: center;
  background: white;
}

.reach {
  width: 90%;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
}

.left-title {
  text-align: left;
}

.right-title {
  text-align: right;
}

.search-text {
  max-width: 500px;
}

.account-select {
  max-width: 200px;
}

.text-danger {
  color: $color-primary !important;
}

.page-class1 button {
  color: $color-primary !important;
  font-size: 50px;
}

.pageinfo {
  font-size: 1.1rem;
  font-weight: bold;
  text-align: left;
}

.filter_date_start {
  width: 200px;
  margin-left: 50px;
}

.filter_date_end {
  width: 200px;
}

.filter_date_to {
  padding: 5px 10px;
}

.filter {
  margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/slc/MSaveListCount.vue